<template>
  <el-card :body-style="bodyStyle">
    <div class="GetStarted--Section">
      <div class="GetStartedInformation--TitleRow">
        <el-tooltip effect="light" :content="getStartedTooltip">
          <i
            class="GetStartedInformationTitle--icon el-icon-warning-outline"
          ></i>
        </el-tooltip>
        <span class="GetStartedSection--Title">{{
          $t('ApplicationsChannels_GetStarted')
        }}</span>
      </div>
      <p class="GetStartedInformation--Description">
        {{ $t('ApplicationsChannels_GetStartedDescription') }}
      </p>
      <div class="GetStartedInformation--Buttons">
        <div
          class="GetStartedInformation--ActivationErrors"
          v-if="!isActivating && activationError"
        >
          <span class="GetStartedInformation--ActivationErrorTitle">{{
            $t('ApplicationsChannels_ActivationErrorTitle')
          }}</span>
          <span class="GetStartedInformation--ActivationErrorSubtitle">{{
            $t('ApplicationsChannels_ActivationErrorSubtitle')
          }}</span>
        </div>
        <el-button
          v-if="!isActivating && activationError"
          type="primary"
          plain
          icon="el-icon-check"
          @click="confirmError"
        >
          {{ $t('ApplicationsChannels_ActivationOk') }}
        </el-button>
        <el-button
          v-if="!activationError"
          :disabled="isActivating"
          type="primary"
          :loading="isActivating"
          icon="el-icon-check"
          @click="activate"
        >
          {{ activationButtonText }}
        </el-button>
        <a :href="docUrl" target="_blank" class="ml-4">
          <el-button v-if="!isActivating && !activationError" empty>
            {{ $t('ApplicationsChannels_ViewDocs') }}
            <i class="el-icon-top-right"></i>
          </el-button>
        </a>
      </div>
    </div>
    <div class="GetStarted--Section">
      <span class="GetStartedSection--Title">{{
        $t('ApplicationsChannels_SDKTitle')
      }}</span>
      <div class="GetStartedSDK--Row">
        <span class="GetStartedSDK--Key">{{ value.appkey }}</span>
        <el-button
          empty
          class="GetStartedSDK--CopyButton"
          icon="el-icon-copy-document"
          size="mini"
          @click="copyAppKey(value.appkey, 'key')"
        ></el-button>
      </div>
      <div v-if="value.type === ApplicationTypes.web">
        <span class="GetStartedSection--Title mt-6">{{
          $t('ApplicationsChannels_SDKIntegrationCode')
        }}</span>
        <div class="GetStartedSDK--Row">
          <code class="GetStartedSDK--Code">{{ value.webpushCode }}</code>
          <el-button
            empty
            class="GetStartedSDK--CopyButton"
            icon="el-icon-copy-document"
            size="mini"
            @click="copyAppKey(value.webpushCode, 'code')"
          ></el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import { ApplicationTypes } from '@/modules/account/enum/ApplicationEnum'

export default {
  name: 'GetStartedBlock',

  data() {
    return {
      ApplicationTypes,
      isActivating: false,
      activationError: false,
      bodyStyle: {
        padding: 0,
        display: 'flex'
      }
    }
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },

  methods: {
    activate() {
      this.isActivating = true
      this.activationError = false
      RestApi({
        ...projectEndpoint({
          method: 'post',
          url: `applications/activate`
        }),
        ...{
          data: {
            id: this.$route.query.id
          }
        }
      })
        .then(({ data }) => {
          if (data.result) {
            this.$message({
              message: this.$t('ApplicationsChannels_ActivationSuccessful'),
              type: 'success'
            })
            this.$emit('reload')
          } else {
            this.activationError = true
          }
          this.isActivating = false
        })
        .catch(error => {
          this.isActivating = false
          this.activationError = true
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    copyAppKey(value, type) {
      this.$emit('copy-key', value, type)
    },
    confirmError() {
      this.isActivating = false
      this.activationError = false
    }
  },
  computed: {
    docUrl() {
      if (this.value.huawei_app_id) {
        return 'https://docs.xtremepush.com/docs/huawei-application'
      } else {
        switch (this.value.type) {
          case ApplicationTypes.web:
            return 'https://docs.xtremepush.com/docs/web-sdk-import'
          case ApplicationTypes.ios:
            return 'https://docs.xtremepush.com/docs/ios-sdk-import'
          case ApplicationTypes.android:
            return 'https://docs.xtremepush.com/docs/android-sdk-import'
        }
      }
    },
    getStartedTooltip() {
      switch (this.value.type) {
        case ApplicationTypes.web:
          return this.$t('ApplicationsChannels_GetStarted_Tooltip_Website')
        case ApplicationTypes.ios:
        case ApplicationTypes.android:
          return this.$t('ApplicationsChannels_GetStarted_Tooltip_App')
      }
    },
    activationButtonText() {
      let translationKeyPrefix = this.isActivating
        ? 'ApplicationsChannels_Activating'
        : 'ApplicationsChannels_Activate'

      switch (this.value.type) {
        case ApplicationTypes.web:
          return this.$t(translationKeyPrefix + 'Website')
        case ApplicationTypes.ios:
        case ApplicationTypes.android:
          return this.$t(translationKeyPrefix + 'App')
      }
    }
  }
}
</script>

<style scoped>
.GetStarted--Container .el-card__body {
  padding: 0;
  display: flex;
}

.GetStarted--Section {
  flex: 50%;
  padding: 24px 32px;
}

.GetStarted--Section:not(:first-child) {
  border-left: 1px solid #f2f5f9;
}

.GetStartedSection--Title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #5c6374;
}

.GetStartedInformation--TitleRow {
  display: flex;
  align-items: center;
}

.GetStartedInformation--TitleRow .GetStartedSection--Title {
  margin-left: 13px;
}

.GetStartedInformationTitle--icon {
  font-size: 20px;
  transform: rotate(180deg);
}

.GetStartedInformation--Description {
  margin-top: 24px;
  margin-right: 88px;

  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #5c6374;
}

.GetStartedInformation--Buttons {
  margin-top: 24px;
  display: flex;
}

.GetStartedInformation--ActivationErrors {
  display: flex;
  flex-direction: column;
  margin-right: 24px;
}

.GetStartedInformation--ActivationErrorTitle {
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #c61016;
}

.GetStartedInformation--ActivationErrorSubtitle {
  font-weight: 600;
  font-size: 10px;
  line-height: 16px;
  color: #f14b53;
}

.GetStartedSDK--Row {
  margin-top: 8px;
  display: flex;
  align-items: flex-start;
}

.GetStartedSDK--Key {
  font-size: 20px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80%;
  max-width: max-content;
  color: #c0c4cc;
}

.GetStartedSDK--Code {
  font-size: 16px;
  line-height: 20px;
  word-break: break-all;
  width: 90%;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  padding: 9px;
}

.GetStartedSDK--CopyButton {
  margin-left: 24px;
  padding: 4px;
}

.ml-4 {
  margin-left: 16px;
}

.mt-6 {
  margin-top: 24px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/modules/account/components/GetStartedBlock.vue